import * as React from "react";
import { SVGProps, memo } from "react";

const SvgBell = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.007 3.3a.9.9 0 0 1 1.8 0v1.018c.97.06 1.874.228 2.52.52A3.843 3.843 0 0 1 17.16 6.51c.384.69.57 1.475.683 2.26.088.608.14 1.274.191 1.942l.045.569c.058.7.536 1.263 1.014 1.828.349.411.697.823.883 1.288.227.569.248 1.134.191 1.704-.058.578-.574.991-1.154.991H4.987c-.58 0-1.096-.413-1.154-.99-.057-.571-.036-1.136.191-1.705.186-.465.535-.877.883-1.289.478-.564.956-1.128 1.014-1.827l.045-.569a30.22 30.22 0 0 1 .19-1.941c.115-.786.3-1.572.684-2.26a3.843 3.843 0 0 1 1.832-1.672c.606-.273 1.436-.439 2.335-.507V3.3Zm7.369 11.991a1.536 1.536 0 0 0-.072-.228c-.108-.27-.289-.524-.554-.843-.053-.065-.111-.133-.173-.205-.49-.571-1.193-1.39-1.292-2.587l-.049-.618c-.05-.656-.096-1.24-.174-1.782-.102-.7-.247-1.235-.475-1.643a2.046 2.046 0 0 0-1-.906c-.509-.23-1.47-.385-2.587-.385-1.117 0-2.078.155-2.586.385-.486.22-.787.521-1.001.906-.228.408-.373.942-.475 1.643-.078.542-.124 1.126-.174 1.782l-.05.618c-.098 1.196-.8 2.016-1.29 2.587-.062.072-.121.14-.174.205-.265.319-.446.573-.554.843a1.537 1.537 0 0 0-.072.228h12.752Z"
      fill="#2BA168"
    />

    <path
      d="M8.316 18.167c0 1.12.474 2.009 1.204 2.6.708.572 1.614.833 2.48.833.867 0 1.773-.26 2.481-.833.73-.591 1.204-1.48 1.204-2.6h-1.8c0 .569-.222.946-.536 1.2-.336.272-.822.433-1.348.433-.526 0-1.013-.161-1.35-.433-.313-.254-.535-.631-.535-1.2h-1.8Z"
      fill="#2BA168"
    />
  </svg>
);

const Memo = memo(SvgBell);

export default Memo;
